import * as React from 'react'

import { Input as AntInput } from 'antd'
import { useField, useFormikContext } from 'formik'

import FormGroup from '../FormGroup'
import DefaultFieldProps from '../FormGroup/DefaultFieldProps'

const { TextArea } = AntInput

type FormikFieldProps = DefaultFieldProps & {
  rows?: number
  cols?: number
  className?: string
  onChange?: (value: string) => void
}

const FormikTextAreaV2: React.FC<FormikFieldProps> = (props) => {
  const [field] = useField(props.name)
  const context = useFormikContext()

  return (
    <FormGroup {...props}>
      <TextArea
        {...props}
        rows={props.rows ?? 4}
        cols={props.cols ?? 10}
        value={field.value}
        onChange={(event: any) => {
          context.setFieldValue(props.name, event.target.value)
          props.onChange && props.onChange(event.target.value)
        }}
      />
    </FormGroup>
  )
}

export default FormikTextAreaV2
